import Http from './Http';

let backendHost = 'https://pubkit.newgen.co/submissions/api/';
let pubkitUrl = 'https://pubkit.newgen.co/';
let xLoginUrl = pubkitUrl + 'auth';
let reportUrl = 'https://pubsub.newgen.co/';
const hostname = window && window.location && window.location.hostname;

if(hostname === 'localhost') {
      // backendHost = 'http://localhost:8083/';
      // pubkitUrl = 'http://localhost:3000/';
      // xLoginUrl = pubkitUrl + 'auth';
      backendHost = 'https://pubkittest.newgen.co/submissions/api/';
      pubkitUrl = 'https://pubkittest.newgen.co/';
      xLoginUrl = 'https://pubkittest.newgen.co/auth';
      reportUrl = 'https://pubsubtest.newgen.co/';
}  
if(hostname === 'newgenklitest.web.app' || hostname === 'mschasing.web.app') {
      backendHost = 'https://pubkittest.newgen.co/submissions/api/';
      pubkitUrl = 'https://pubkittest.newgen.co/';
      xLoginUrl = 'https://pubkittest.newgen.co/auth';
      reportUrl = 'https://pubsubtest.newgen.co/';
}  
const parseJson = res => res.json();
const defaultConfig = () => ({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'access-control-allow-origin': '*',
    Origin: 'https://pubkit.newgen.co',
  },
});
const reportConfig = () => ({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'access-control-allow-origin': '*',
    Origin: 'https://pubkit.newgen.co',
    "email": JSON.parse(localStorage.getItem("credentials"))["email"],
    "token": JSON.parse(localStorage.getItem("credentials"))["token"]
  },
});
export const genericApi = new Http(backendHost +"kli-api/looseleaves/approved_queries/", defaultConfig);
export const reportApi = new Http(reportUrl +"reportsmicro/reports/approved_queries/", reportConfig);

export const messagefromparnersDataUrl = {
  get: params => genericApi.post('processed_msg_from_partners', params).then(parseJson),
};
export const messagefromparneridentifierUrl = {
  get: params => reportApi.post('message_from_partners', params).then(parseJson),
};
export const awaitingAcquisitionsUrl = backendHost + "kli-api/looseleaves/acquisitions/awaitings";
export const klicountry = backendHost + "kli-api/looseleaves/country";
export const projectTitle = backendHost + "kli-api/looseleaves/projectTitle";
export const inAcquisitionsUrl = backendHost + "kli-api/looseleaves/acquisitions/progress";
export const plannedAcquisitionUrl = backendHost + "kli-api/looseleaves/acquisitions/planned";
export const selectedLooseLeafUrl = backendHost + "kli-api/looseleaves/{id}";
export const lapsapicalllogs = backendHost + "kli-api/looseleaves/lapsapicalllogs/{lapsId}";
export const mailFinder = backendHost + "kli-api/looseleaves/mailfinder";
export const linkeddois = backendHost + "kli-api/looseleaves/linkeddois";
export const chasingList = backendHost + "kli-api/looseleaves/chasingunit";
export const createSeedUrl = backendHost + "kli-api/looseleaves/create";
export const createArbitratorSeedUrl = backendHost + "kli-api/looseleaves/create_arbitrator_profile";
export const createBooksSeedUrl = backendHost + "kli-api/looseleaves/create_book_dashboard";
export const insertlog = backendHost + "kli-api/looseleaves/insertlog";
export const UpdateDoi = backendHost + "kli-api/looseleaves/doilinkupdated";
export const updateSeedUrl = backendHost + "kli-api/looseleaves/update";
export const saveScheduleUrl = backendHost + "kli-api/looseleaves/schedule";
export const finalizeScheduleUrl = backendHost + "kli-api/looseleaves/finalize";
export const dashboardDataUrl = backendHost + "kli-api/looseleaves/acquisitions/dashboard";
export const arbitratordashboardDataUrl = backendHost + "kli-api/looseleaves/acquisitions/arbitratorDashboard";
export const booksdashboardDataUrl = backendHost + "kli-api/looseleaves/acquisitions/bookDashboard";
//export const messagefromparnersDataUrl = backendHost + "kli-api/looseleaves/approved_queries/unprocessed_msg_from_partners";
export const updateLooseLeafAttributesUrl = backendHost + "kli-api/looseleaves/update_attributes";
export const updateArbitratorAttributesUrl = backendHost + "kli-api/looseleaves/update_arbitrator_profile";
export const updateBooksAttributesUrl = backendHost + "kli-api/looseleaves/update_book_dashboard";
export const pepoleWip = pubkitUrl + "api/replace_project_user";
export const ArbitratorpepoleWip = pubkitUrl + "api/add_freelancer_to_project";
export const editUsername = pubkitUrl + "api/get_user_name";
export const newUser = pubkitUrl + "api/user_create";
export const editUser = pubkitUrl + "api/user_update";
export const holdWip = pubkitUrl + "api/project_hold_release";
export const updateTitleActorInfo = backendHost + "kli-api/looseleaves/update_title_actor_info";
export const getTitleEmailUrl = `${backendHost}kli-api/looseleaves/get_title_actor_info`;
export const deleteLooseLeadUrl = `${backendHost}kli-api/looseleaves/delete_loose_leaf`;
export const getWorkflow = reportUrl +'reportsmicro/reports/approved_queries/cbdworkflownames';
export const getTaskwithoutworkflow = reportUrl +'reportsmicro/reports/approved_queries/cbdtasknames';
export const getTask = reportUrl +'reportsmicro/reports/approved_queries/cbdworkflowtasksname';
export const wippepole = reportUrl +'reportsmicro/reports/approved_queries/wippepole';
export const getcbdcountrynames = reportUrl +'reportsmicro/reports/approved_queries/cbdcountrynames';
export const klicountrynames= reportUrl +'reportsmicro/reports/approved_queries/klicountryname';
export const loginUrl = xLoginUrl;
export const autoLoginUrl = pubkitUrl+'submissions/authenticateparams';
export const changePasswordUrl = pubkitUrl + 'users/update_password_with_token';
export const addUserToWip = pubkitUrl + 'api/add_user_to_wip';
export const removeUserFromWip = pubkitUrl + 'api/remove_user_from_wip';
export const paginationmsgfrmpartner = backendHost + "kli-api/looseleaves/processed_message_from_partners";


const Api = {
      messagefromparnersDataUrl,
      messagefromparneridentifierUrl
   
    };
export default Api;